// topOffset = 0 means the top half will be all the way full
// topOffset = 39 means the top half will be all the way empty
// bottomOffset = 0 means the bottom half will be all the way empty
// bottomOffset = 37 means the bottom half will be all the way full
import React, { useState } from "react";

const TimerGraphic = ({
  topOffset,
  bottomOffset,
  remainingSeconds,
  timerCount,
  isFlipped,
  isSandFallingIntoPlace,
}) => {
  return (
    <div
      className="App-hourglass"
      style={{
        width: "100%",
        position: "absolute",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "2",
      }}
    >
      <div
        style={{
          width: "270px",
          position: "relative",
          transform: isFlipped ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 2s",
        }}
      >
        <TimerHalf
          sandOffset={4 + (topOffset ?? 0)}
          style={{ transform: "rotateZ(180deg)" }}
          isSandFallingIntoPlace={!isFlipped && isSandFallingIntoPlace}
        />
        <TimerHalf
          sandOffset={-44 + (bottomOffset ?? 0)}
          style={{ marginTop: "-10px" }}
          isSandFallingIntoPlace={isFlipped && isSandFallingIntoPlace}
        />
      </div>
    </div>
  );
};

const TimerHalf = ({ style, sandOffset, isSandFallingIntoPlace }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72.037148 53.112579"
    style={style}
  >
    <defs>
      <clipPath id="a" clipPathUnits="userSpaceOnUse">
        <path
          d="M9.3103838 109.32832c-2.6319004 16.07102 10.1749092 31.77403 21.0313402 37.36109 5.657919 2.91175 7.425499 5.39805 7.423399 7.52881h7.11686c-.0021-2.13076 1.76548-4.61706 7.423412-7.52881 10.856426-5.58706 23.663238-21.29007 21.03133-37.36109z"
          style={{
            display: "inline",
            fill: "#000",
            fillPpacity: 1,
            fillRule: "evenodd",
            stroke: "#000",
            strokeWidth: 1.32292,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 1,
          }}
        />
      </clipPath>
    </defs>
    <g style={{ display: "inline" }}>
      <g clip-path="url(#a)" transform="rotate(180 38.671065 77.721715)">
        <path
          d="M73.865191 137.004v-21.64522c-3.374369.20056-7.135811-.2482-11.66163-1.97981-18.304776-7.00715-24.098827 7.01067-42.421197.00002-4.23034-1.61939-7.79253-2.11584-10.99555-2.00841l.005 3.9882-.01 21.64522c19.32719.0309 25.4753 15.60776 32.536938 15.65846m.000096 0c7.194303-.0517 13.210243-15.62753 32.546443-15.65846"
          style={{
            display: "inline",
            fill: "#e5cfab",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "#000",
            strokeWidth: 1.31116,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transform: `translateY(${sandOffset}px)`,
            transition: isSandFallingIntoPlace ? "transform 500ms" : "",
          }}
        />
      </g>
      <g style={{ display: "inline" }}>
        <path
          fill="none"
          d="M64.952103 96.64222H130.6383c1.44968 0 2.61674 1.429239 2.61674 3.204572 0 1.775328-1.16706 3.204568-2.61674 3.204568H64.952103c-1.449673 0-2.616738-1.42924-2.616738-3.204568 0-1.775333 1.167065-3.204572 2.616738-3.204572z"
          style={{
            display: "inline",
            fill: "#60f",
            fillOpacity: 0,
            fillRule: "evenodd",
            stroke: "#000",
            strokeWidth: 1.11748,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 1,
          }}
          transform="rotate(180 66.90689015 74.5980225)"
        />
        <g style={{ display: "inline" }}>
          <path
            d="M94.331022 148.5c.0021-2.13076-1.765476-4.61706-7.423395-7.52881-10.856432-5.58706-23.663243-21.29007-21.031339-37.36109M101.44788 148.5c-.002-2.13076 1.76548-4.61706 7.42341-7.52881 10.85643-5.58706 23.66324-21.29007 21.03133-37.36109"
            style={{
              fill: "none",
              fillOpacity: 0.5,
              fillRule: "evenodd",
              stroke: "#000",
              strokeWidth: 1.32292,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeOpacity: 1,
            }}
            transform="rotate(180 66.9540127 74.580725)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export { TimerGraphic };
